"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitDependencies = exports.getInitDependenciesFactory = void 0;
var web_ui_framework_1 = require("@gruposantander/web-ui-framework");
Object.defineProperty(exports, "getInitDependenciesFactory", { enumerable: true, get: function () { return web_ui_framework_1.getInitDependenciesFactory; } });
Object.defineProperty(exports, "getInitDependencies", { enumerable: true, get: function () { return web_ui_framework_1.getInitDependencies; } });
__exportStar(require("./dependencies"), exports);
__exportStar(require("./initDependenciesFactory"), exports);
//# sourceMappingURL=index.js.map